module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "featured-protocol"
  }, [_c('div', {
    staticClass: "protocol"
  }, [_c('h2', [_c('router-link', {
    attrs: {
      "to": {
        name: 'protocol',
        params: {
          slug: _vm.protocol._source.slug
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.protocol._source.title))])], 1), _vm._v(" "), (_vm.info('time-estimate')) ? _c('div', {
    attrs: {
      "id": "time"
    }
  }, [_vm._v(_vm._s(_vm.info('time-estimate')))]) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "id": "author"
    }
  }, [_vm._v("Author: " + _vm._s(_vm.protocol._source.author) + "\n      "), (_vm.hasContent('partner')) ? _c('span', {
    attrs: {
      "id": "partner"
    }
  }, [_vm._v(" | Partner: " + _vm._s(_vm.protocol._source.partner))]) : _vm._e()]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "preview"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.makeHtml(_vm.protocol._source.markdown.preview))
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dc4e5fb0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeaturedProtocol.vue
// module id = 249
// module chunks = 2